import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";

export default function simulatieDossierReducer(state = initialState.simulatieDossier, action) {
	switch (action.type) {
		case types.SIMULATIEDOSSIER_LOADED: {
			return mergeDeep({}, {
				item: action.body.item,
				isLoaded: true,
				isSaved: action.body.isSaved
			});
		}

		case types.SIMULATIEINFRASTRUCTUREN_LOADED: {
			let stateToUpdate = mergeDeep({}, state);
			const inEditMode = action.body.inEditMode;
			const sportinfrastructurenInDeBuurt = action.body.item.infrastructuren.filter(i => i.tienMinutenWandelen);
			const spakkiIdsVanSportinfrastructurenInDeBuurt = stateToUpdate.item.sportinfrastructurenInDeBuurt.filter(s => s.spakki != null).map(s => s.spakki.id);

			const nieuweSportinfrastructurenInDeBuurt = sportinfrastructurenInDeBuurt.filter(s => s.spakki != null && !spakkiIdsVanSportinfrastructurenInDeBuurt.includes(s.spakki.id));

			// lijst van reeds opgeslagen infrastructuren en nieuwe infrastructuren in de buurt
			let sportinfrastructurenInDeBuurtReedsInProject = stateToUpdate.item.sportinfrastructurenInDeBuurt.concat(nieuweSportinfrastructurenInDeBuurt);
			let sportinfrastructurenOpKaartReedsInProject = [];
			if (inEditMode == "false" || inEditMode === false) {
				sportinfrastructurenOpKaartReedsInProject = stateToUpdate.item.sportinfrastructurenInDeBuurt.filter(i => i.deelVanAanvraag === 2 || i.deelVanAanvraag == "2" || i.deelVanAanvraag === 0 || i.deelVanAanvraag == "0").concat(sportinfrastructurenInDeBuurt);
			}
			else {
				sportinfrastructurenOpKaartReedsInProject = sportinfrastructurenInDeBuurtReedsInProject;
			}

			let item = action.body.project === null ? stateToUpdate.item : action.body.project;

			return Object.assign({}, stateToUpdate,
				{
					item: Object.assign({}, item,
						{ sportinfrastructurenOpKaart: sportinfrastructurenOpKaartReedsInProject },
						{ sportinfrastructurenInDeBuurt: sportinfrastructurenInDeBuurtReedsInProject },
						{ straatHuisnummer: action.body.straat },
						{ gemeente: action.body.gemeente },
						{ postcode: action.body.postcode })
				});
		}

		case types.SIMULATIEINFRASTRUCTUUR_VALIDATED: {
			return Object.assign({}, state,
				{
					infrastructuurErrors: action.body.errors
				});
		}

		case types.SIMULATIEINFRASTRUCTUUR_SAVED: {
			let stateToUpdate = mergeDeep({}, state);
			let buurtItems = stateToUpdate.item.sportinfrastructurenInDeBuurt;
			let kaartItems = stateToUpdate.item.sportinfrastructurenOpKaart;

			let newBuurtItems = [...buurtItems.filter(x => x.id != action.body.item.id), action.body.item];
			let newKaartItems = [...kaartItems.filter(x => x.id != action.body.item.id), action.body.item];

			stateToUpdate.item.sportinfrastructurenInDeBuurt = newBuurtItems;
			stateToUpdate.item.sportinfrastructurenOpKaart = newKaartItems;

			stateToUpdate.isSaved = action.body.isReset && stateToUpdate.isSaved;

			return stateToUpdate;
		}

		case types.SIMULATIEINFRASTRUCTUUR_REMOVED: {
			let stateToUpdate = mergeDeep({}, state);
			let buurtItems = stateToUpdate.item.sportinfrastructurenInDeBuurt;
			let kaartItems = stateToUpdate.item.sportinfrastructurenOpKaart;

			let newBuurtItems = [...buurtItems.filter(x => x.id != action.body.item)];
			let newKaartItems = [...kaartItems.filter(x => x.id != action.body.item)];

			stateToUpdate.item.sportinfrastructurenInDeBuurt = newBuurtItems;
			stateToUpdate.item.sportinfrastructurenOpKaart = newKaartItems;

			return stateToUpdate;
		}

		default:
			return state;
	}
}
